import { render, staticRenderFns } from "./Promoters.vue?vue&type=template&id=5c8ee0f0&"
import script from "./Promoters.vue?vue&type=script&lang=js&"
export * from "./Promoters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports